import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "p-fluid p-formgrid p-grid p-input-filled" }
const _hoisted_2 = { class: "p-field p-col-6" }
const _hoisted_3 = { for: "name" }
const _hoisted_4 = {
  key: 0,
  class: "p-error"
}
const _hoisted_5 = {
  key: 1,
  class: "p-error"
}
const _hoisted_6 = { class: "p-field p-col-6" }
const _hoisted_7 = { for: "description" }
const _hoisted_8 = {
  key: 0,
  class: "p-error"
}
const _hoisted_9 = { class: "p-field p-col-6" }
const _hoisted_10 = { for: "locatorId" }
const _hoisted_11 = { class: "p-field p-col-6" }
const _hoisted_12 = { for: "externalName" }
const _hoisted_13 = { class: "p-field p-col-12" }
const _hoisted_14 = { for: "tableBehaviour" }
const _hoisted_15 = { class: "p-input-icon-right" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("i", {
  class: "mdi mdi-comment-question-outline p-mr-4",
  style: {"top":"47%"}
}, null, -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("div", { class: "p-field p-col-12" }, null, -1)
const _hoisted_18 = { class: "p-field p-col-3" }
const _hoisted_19 = { for: "mandatory" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_21 = { class: "p-field p-col-3" }
const _hoisted_22 = { for: "readonly" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_24 = { class: "p-field p-col-3" }
const _hoisted_25 = { for: "hidden" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_27 = { class: "p-field p-col-3" }
const _hoisted_28 = { for: "forceValidation" }
const _hoisted_29 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_30 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_31 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_32 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_33 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_34 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_35 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_36 = /*#__PURE__*/_createElementVNode("br", null, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_Checkbox = _resolveComponent("Checkbox")!
  const _component_Message = _resolveComponent("Message")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("label", _hoisted_3, _toDisplayString(_ctx.$t('Squeeze.DocumentClasses.Name')) + " *", 1),
      _createVNode(_component_InputText, {
        id: "name",
        modelValue: _ctx.v$.name.$model,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.v$.name.$model) = $event)),
        modelModifiers: { trim: true },
        class: _normalizeClass({'p-invalid':_ctx.v$.name.$invalid && _ctx.showErrorMessage}),
        onChange: _ctx.update,
        required: "true",
        autofocus: ""
      }, null, 8, ["modelValue", "class", "onChange"]),
      (_ctx.v$.name.required.$invalid && _ctx.showErrorMessage && !_ctx.v$.name.technicalValidation.$invalid)
        ? (_openBlock(), _createElementBlock("small", _hoisted_4, _toDisplayString(_ctx.$t('Forms.Val.MissingRequired', { field: _ctx.$t('Squeeze.DocumentClasses.Name')})), 1))
        : _createCommentVNode("", true),
      (_ctx.v$.name.technicalValidation.$invalid && _ctx.showErrorMessage)
        ? (_openBlock(), _createElementBlock("small", _hoisted_5, _toDisplayString(_ctx.$t('Forms.Val.OnlyAllowAlphaNumericUnderscore', { field: _ctx.$t('Squeeze.DocumentClasses.Name')})), 1))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("label", _hoisted_7, _toDisplayString(_ctx.$t('Squeeze.DocumentClasses.Description')) + " *", 1),
      _createVNode(_component_InputText, {
        id: "description",
        modelValue: _ctx.v$.description.$model,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.v$.description.$model) = $event)),
        modelModifiers: { trim: true },
        class: _normalizeClass({'p-invalid':_ctx.v$.description.$invalid && _ctx.showErrorMessage}),
        onChange: _ctx.update,
        required: "true"
      }, null, 8, ["modelValue", "class", "onChange"]),
      ((_ctx.v$.description.$invalid && _ctx.showErrorMessage))
        ? (_openBlock(), _createElementBlock("small", _hoisted_8, _toDisplayString(_ctx.$t('Forms.Val.MissingRequired', { field: _ctx.$t('Squeeze.DocumentClasses.Description')})), 1))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_9, [
      _createElementVNode("label", _hoisted_10, _toDisplayString(_ctx.$t('Squeeze.DocumentClasses.Locator')), 1),
      _createVNode(_component_Dropdown, {
        id: "locatorId",
        modelValue: _ctx.value.locatorId,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.value.locatorId) = $event)),
        options: _ctx.locators,
        filter: true,
        autoFilterFocus: true,
        optionValue: "id",
        optionLabel: "description",
        showClear: true,
        editable: false,
        onChange: _ctx.onChangeDropDown,
        onShow: _ctx.showDropdownOverlay
      }, null, 8, ["modelValue", "options", "onChange", "onShow"])
    ]),
    _createElementVNode("div", _hoisted_11, [
      _createElementVNode("label", _hoisted_12, _toDisplayString(_ctx.$t('Squeeze.DocumentClasses.ExternalName')), 1),
      _createVNode(_component_InputText, {
        id: "externalName",
        modelValue: _ctx.value.externalName,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.value.externalName) = $event)),
        modelModifiers: { trim: true },
        required: "true"
      }, null, 8, ["modelValue"])
    ]),
    _createElementVNode("div", _hoisted_13, [
      _createElementVNode("label", _hoisted_14, _toDisplayString(_ctx.$t('Squeeze.DocumentClasses.TableBehaviour')), 1),
      _withDirectives((_openBlock(), _createElementBlock("span", _hoisted_15, [
        _hoisted_16,
        _createVNode(_component_Dropdown, {
          id: "tableBehaviour",
          modelValue: _ctx.value.tableBehaviour,
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.value.tableBehaviour) = $event)),
          options: _ctx.tablesBehaviours,
          optionValue: "id",
          optionLabel: "description",
          onChange: _ctx.onChangeDropDown,
          onShow: _ctx.showDropdownOverlay
        }, null, 8, ["modelValue", "options", "onChange", "onShow"])
      ])), [
        [
          _directive_tooltip,
          _ctx.$t('Squeeze.DocumentClasses.TableBehaviourDescription'),
          void 0,
          { bottom: true }
        ]
      ])
    ]),
    _hoisted_17,
    _createElementVNode("div", _hoisted_18, [
      _createElementVNode("label", _hoisted_19, _toDisplayString(_ctx.$t('Squeeze.DocumentClasses.Mandatory')), 1),
      _hoisted_20,
      _createVNode(_component_Checkbox, {
        id: "mandatory",
        modelValue: _ctx.value.mandatory,
        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.value.mandatory) = $event)),
        binary: true,
        onChange: _cache[6] || (_cache[6] = ($event: any) => (_ctx.onChangeCheckBox('mandatory')))
      }, null, 8, ["modelValue"])
    ]),
    _createElementVNode("div", _hoisted_21, [
      _createElementVNode("label", _hoisted_22, _toDisplayString(_ctx.$t('Squeeze.DocumentClasses.ReadOnly')), 1),
      _hoisted_23,
      _createVNode(_component_Checkbox, {
        id: "readonly",
        modelValue: _ctx.value.readonly,
        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.value.readonly) = $event)),
        binary: true,
        onChange: _cache[8] || (_cache[8] = ($event: any) => (_ctx.onChangeCheckBox('readonly')))
      }, null, 8, ["modelValue"])
    ]),
    _createElementVNode("div", _hoisted_24, [
      _createElementVNode("label", _hoisted_25, _toDisplayString(_ctx.$t('Squeeze.DocumentClasses.Hidden')), 1),
      _hoisted_26,
      _createVNode(_component_Checkbox, {
        id: "hidden",
        modelValue: _ctx.value.hidden,
        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.value.hidden) = $event)),
        binary: true,
        onChange: _cache[10] || (_cache[10] = ($event: any) => (_ctx.onChangeCheckBox('hidden')))
      }, null, 8, ["modelValue"])
    ]),
    _createElementVNode("div", _hoisted_27, [
      _createElementVNode("label", _hoisted_28, _toDisplayString(_ctx.$t('Squeeze.DocumentClasses.ForceValidation')), 1),
      _hoisted_29,
      _createVNode(_component_Checkbox, {
        id: "forceValidation",
        modelValue: _ctx.value.forceValidation,
        "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.value.forceValidation) = $event)),
        binary: true,
        onChange: _cache[12] || (_cache[12] = ($event: any) => (_ctx.onChangeCheckBox('forceValidation')))
      }, null, 8, ["modelValue"])
    ]),
    ((_ctx.tablesWithLocators.length > 0 || _ctx.activeTableId !== _ctx.value.id || _ctx.activeTableId === 0) && _ctx.activeTableId !== -1)
      ? (_openBlock(), _createBlock(_component_Message, {
          key: 0,
          severity: "warn",
          closable: false
        }, {
          default: _withCtx(() => [
            (_ctx.tablesWithLocators.length > 0)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createTextVNode(_toDisplayString(_ctx.$t('Squeeze.Locators.CautionLineItems')), 1),
                  _hoisted_30,
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tablesWithLocators, (table) => {
                    return (_openBlock(), _createElementBlock(_Fragment, {
                      key: table.id
                    }, [
                      _createTextVNode(_toDisplayString(table.description) + " (ID: " + _toDisplayString(table.id) + ", " + _toDisplayString(_ctx.$t('Squeeze.DocumentClasses.DocumentClass')) + ": " + _toDisplayString(_ctx.getDocumentDocumentClassLabel(table.documentClassId)) + ")", 1),
                      _hoisted_31
                    ], 64))
                  }), 128)),
                  _hoisted_32,
                  _createTextVNode(_toDisplayString(_ctx.$t('Squeeze.Locators.CautionLineItems2')), 1),
                  _hoisted_33,
                  _hoisted_34
                ], 64))
              : _createCommentVNode("", true),
            (_ctx.activeTableId !== _ctx.value.id && _ctx.activeTableId !== 0)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createTextVNode(_toDisplayString(_ctx.$t('Squeeze.Locators.CautionLineItems4')), 1),
                  _hoisted_35,
                  _createTextVNode(" " + _toDisplayString(_ctx.getTableDescription(_ctx.activeTableId)), 1)
                ], 64))
              : (_ctx.activeTableId === 0)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                    _createTextVNode(_toDisplayString(_ctx.$t('Squeeze.Locators.CautionLineItems5')), 1),
                    _hoisted_36
                  ], 64))
                : _createCommentVNode("", true)
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ]))
}